module.exports = __webpack_public_path__ + "img/users.7f087b74.png";